import { gql } from '@apollo/client';

// After a routed order's services change, null the containing stops' service_time so the next
// route map recomputes them from the updated services, and flag the route for re-optimize.
// Completed stops are left untouched so their historical dwell isn't wiped.
export const RECALCULATE_STOP_SERVICE_TIMES = gql`
    mutation RecalculateStopServiceTimes($stop_ids: [uuid!] = [], $route_ids: [uuid!] = []) {
        update_stops(
            where: { stop_id: { _in: $stop_ids }, stop_completion_time: { _is_null: true } }
            _set: { service_time: null }
        ) {
            returning {
                stop_id
                service_time
            }
        }
        update_routes(where: { route_id: { _in: $route_ids } }, _set: { need_to_optimize: true }) {
            returning {
                route_id
                need_to_optimize
            }
        }
    }
`;
